import React, { Component } from 'react';
import Filter from './filter';
import Deals from './deals';
import Modal from "react-bootstrap/Modal";
import {ApiBaseUrl} from '../../../constants';
import { AuthContext } from "./../../../context/auth";
import InfiniteScroll from 'react-infinite-scroller';
import { trackPromise } from 'react-promise-tracker';
import {withSnackbar} from "react-simple-snackbar";

class CategoryDealsComponent extends Component {
    static contextType = AuthContext;
    state = {
        categories: [],
        deals: [],
        selectedCategories: [],
        hasMoreItems: false,
        page: 1,
        loginmodal: false,
        toggleEvent: 0
    }

    onToggle = () => {
        this.setState({ toggleEvent: new Date() });
    };

    orderBy = 'default';

    shouldComponentUpdate(nextProps, nextState) {
        if(nextState.toggleEvent!== this.state.toggleEvent || nextState.categories!== this.state.categories || nextState.page !== this.state.page || nextState.deals !== this.state.deals || nextState.loginmodal !== this.state.loginmodal)
            return true;
        else
            return false;
    }

    componentWillUnmount () {
        document.getElementById('body').className=''
    }

    componentDidMount(){
        window.scrollTo(0, 0)
        var categories = [];
        const query = new URLSearchParams(this.props.location.search);
        if(query.has('orderby')) {
            this.orderBy = query.get('orderby');
        }
        if(query.has('categories')) {
            categories = query.getAll('categories');
        }

        trackPromise(
        fetch(ApiBaseUrl+"/consumer/filter_categories")
            .then(res => res.json())
            .then(
                (result) => {
                    categories.forEach(categoryId => {
                        var category = result.data.categories.find(category => (category._id===categoryId));
                        if(typeof(category) !== 'undefined')
                            this.state.selectedCategories.push(category);
                    })

                    this.setState({
                        categories: result.data.categories,
                        hasMoreItems: true
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
        )
    }

    handleLoginModalClose = () => {
        this.setState({
            loginmodal : false
        })
    }

    handleLoginModalConfirm = () => {
        this.handleLoginModalClose();
        this.props.history.push(process.env.PUBLIC_URL+'/login')
    }

    handleFavourite = (index) => {
        if(!this.context.authenticated) {
            this.setState({
                loginmodal: true
            })
            return;
        }
        const id = this.state.deals[index]._id;
        fetch(ApiBaseUrl + "/consumer/favourite/"+id,
            {
                method: 'GET',
                headers:
                    {
                        "Authorization": "Bearer "+this.context.token
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if(result.success) {
                        let deals = [...this.state.deals]
                        deals[index].is_favourite = !deals[index].is_favourite;
                        this.setState({
                            deals: deals
                        });
                    }
                    this.props.openSnackbar(result.message)
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
    }

    loadItems() {
        var categories = [];
        const query = new URLSearchParams(this.props.location.search);
        let pickDealBody = 'orderby=default';
        if(query.has('orderby')) {
            pickDealBody = 'orderby=' + query.get('orderby');
            this.orderBy = query.get('orderby');
        }
        if(query.has('categories')) {
            categories = query.getAll('categories');
            pickDealBody +='&categories='+[...categories].join(',');
        }

        let offset=this.state.page;
        pickDealBody += '&offset='+offset;
        const requestHeaders = (!this.context.authenticated) ?
            {
                "Content-Type" : "application/x-www-form-urlencoded"
            } :
            {
                "Content-Type" : "application/x-www-form-urlencoded",
                "Authorization": "Bearer "+this.context.token
            }
        trackPromise(
        fetch(ApiBaseUrl+"/consumer/allday/pick_deals",
            {
                method: 'POST',
                body: pickDealBody,
                headers: requestHeaders
            })
            .then(res => res.json())
            .then(
                (result) => {
                    result.data.map(deal => (
                        this.state.deals.push(deal)
                    ));

                    if(result.data.length > 0) {
                        document.getElementById('body').className = 'pagi-page'
                        this.setState({hasMoreItems: true, page: this.state.page+1})
                    }
                    else
                        this.setState({hasMoreItems: false})
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        hasMoreItems: false
                    });
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
        )
    }

    render() {
        var deals = [];
        let msg = null;
        if(this.state.deals.length===0) {
            msg = (<div className="col-12 text-center text-white">
                No deals available yet.
            </div>)
        }
        else {
            this.state.deals.map((deal, index) => (
                deals.push(
                    <Deals index={index} key={deal._id} handleFavourite={index => this.handleFavourite(index)}
                           selectedCategories={this.state.selectedCategories} deal={deal}/>
                )
            ));
        }
        return (
            <React.Fragment>
                <Modal id="unfollow-pop" show={this.state.loginmodal} aria-labelledby="unfollow-pop" animation="fade">
                    <Modal.Header className="modal-header">
                        <p className="big-alert-text"><i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            Alert
                        </p>
                        <button onClick={this.handleLoginModalClose} type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </Modal.Header>
                    <Modal.Body className="modal-body">
                        <p className="unfollow-para">You have to login/register to proceed further.</p>
                    </Modal.Body>
                    <Modal.Footer className="modal-footer">
                        <button type="button" onClick={this.handleLoginModalConfirm} className="btn btn-secondary" >Ok</button>
                        <button type="button" onClick={this.handleLoginModalClose} className="btn btn-primary" data-dismiss="modal">Cancel</button>
                    </Modal.Footer>
                </Modal>

                <div className="choose-deals-outer p-l-0 p-r-0">
                    <div className="row filter-icon-box">
                        <div className="container">
                            <div className="filter-icon-box--inner  filter-tg d-none d-lg-block">
                                Filter
                                <i className="fa fa-filter" aria-hidden="true"></i>
                            </div>
                            <div onClick={this.onToggle} className="filter-icon-box--inner filter-tg filter-icon d-lg-none mt-1">
                                <img src={`${process.env.PUBLIC_URL}/image/setting-lines.svg`} alt="..."/>

                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <Filter toggleEvent={this.state.toggleEvent} orderBy={this.orderBy} selectedCategories={this.state.selectedCategories} categories={this.state.categories}/>
                            <div className="col-xl-9 px--xs-0">
                                <div className="each-category-outer pick-deal">
                                    <div className="category-header scroller mt-0 mb-4">
                                        {this.state.selectedCategories.map(selectedcategory => {return (
                                            <span key={selectedcategory._id} className="tag">{selectedcategory.name}</span>
                                        )})}
                                    </div>
                                    {msg}
                                    <InfiniteScroll
                                        className="row"
                                        pageStart={1}
                                        loadMore={this.loadItems.bind(this)}
                                        hasMore={this.state.hasMoreItems}>
                                        {deals}
                                    </InfiniteScroll>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default withSnackbar(CategoryDealsComponent,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});